import { render, staticRenderFns } from "./preStaffExtra.vue?vue&type=template&id=1315e1d8&scoped=true&"
import script from "./preStaffExtra.vue?vue&type=script&lang=js&"
export * from "./preStaffExtra.vue?vue&type=script&lang=js&"
import style0 from "./preStaffExtra.vue?vue&type=style&index=0&id=1315e1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1315e1d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
